export var darkModeColorHexValuesMap = new Map([
    ['grey', '808080'],
    ['red', 'D7494C'],
    ['orange', 'F87529'],
    ['marigold', 'C9A618'],
    ['lime', '81B537'],
    ['teal', '2AA0A4'],
    ['blue', '1A86D9'],
    ['lavender', '8171EB'],
    ['lilac', 'BA58C9'],
    ['pink', 'E43BA6'], // pink primary
]);
export var lightModeColorHexValuesMap = new Map([
    ['grey', '616161'],
    ['red', 'D13438'],
    ['orange', 'DF590B'],
    ['marigold', 'AE8C00'],
    ['lime', '679A20'],
    ['teal', '159196'],
    ['blue', '0078D4'],
    ['lavender', '7160E8'],
    ['lilac', 'B146C2'],
    ['pink', 'E43BA6'], // pink primary
]);
export var defaultColorValues = [
    'grey',
    'red',
    'orange',
    'marigold',
    'lime',
    'teal',
    'blue',
    'lavender',
    'lilac',
    'pink',
];
export var defaultColorValue = defaultColorValues[0];
export var maxInputCharacterLength = 64; // 64 is also the limit imposed by Folders SDK
//# sourceMappingURL=Constants.js.map